import React, { Component } from 'react'
class ResultBanner extends Component {

    render() {
        return (
            <div class="result-banner-container" style={this.props.bannerMargin !== undefined ? { marginBottom: this.props.bannerMargin } : {}}>
                <div class="result-banner-inner-divs quarter quarter-left  result-banner-inner-divs-name">
                    <p class="result-banner-inner-divs-p">{this.props.familyLtn}</p>
                    <p class="result-banner-inner-divs-p result-banner-inner-div-tr">{this.props.family}</p>
                    <p class="result-banner-inner-divs-p">{this.props.familyEn}</p>
                </div>
                <div class="result-banner-inner-divs half result-banner-inner-divs-name" style={{ width: "50%" }}>
                    <p class="result-banner-inner-divs-p result-banner-middle-p">{this.props.resultNameLtn}</p>
                    <p class="result-banner-inner-divs-p result-banner-middle-p result-banner-middle-p-tr">{this.props.resultName}</p>
                    <p class="result-banner-inner-divs-p result-banner-middle-p">{this.props.resultNameEn}</p>
                </div>
                <div class="result-banner-inner-divs quarter quarter-right">
                    <img src={this.props.image} class="result-banner-inner-right-img"></img>
                    <div class="result-size-indicater-inner-container">
                        <div class="size-indicator-uplow size-indicater-upper-div">
                            <span class="result-banner-inner-divs-p" style={{ fontStyle: "initial" }}>{this.props.size}</span>
                        </div>
                        <div class="size-indicator-uplow">
                            <span class="result-banner-inner-divs-p" style={{ fontStyle: "initial" }}>{this.props.sizeCm}</span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ResultBanner